import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import { FormFieldContextValue, FormItemContextValue } from './interface';

export const FormFieldContext = React.createContext<FormFieldContextValue>({} as FormFieldContextValue);
export const FormItemContext = React.createContext<FormItemContextValue>({} as FormItemContextValue);

export const useFormField = () => {
  const fieldContext = React.useContext(FormFieldContext);
  const itemContext = React.useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();
  const fieldState = getFieldState(fieldContext.name, formState);
  if (!fieldContext) throw new Error('useFormField must be inside <FormField>');
  return { id: itemContext.id, name: fieldContext.name, formItemId: `${itemContext.id}-item`, formMessageId: `${itemContext.id}-message`, ...fieldState };
};
